"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");

var date_fns_1 = require("date-fns");

var livedInSameStateSince_1 = __importDefault(require("../addresses/livedInSameStateSince"));

var sortFillAddressesDates_1 = __importDefault(require("../addresses/sortFillAddressesDates"));

function determineExemptionState() {
  var addresses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  // If no addresses, return nothing
  if (addresses.length === 0) return null; // Sort Most Recent Addressses

  var sortedAndFilledAddresses = (0, sortFillAddressesDates_1.default)(addresses, function (address) {
    return address.country === "US" || address.country === null || address.country === "";
  }); // If same state for 2 years, that's the state to use

  if ((0, livedInSameStateSince_1.default)(sortedAndFilledAddresses, (0, date_fns_1.subYears)(new Date(), 2))) {
    return (0, lodash_1.get)(sortedAndFilledAddresses, "[0].state");
  } // Otherwise use the address where a person lived the longest in the 730 + 180 period
  // Default endedAt dates to today if none defined


  var addressesOrderedByDaysOverlap = (0, lodash_1.orderBy)(sortedAndFilledAddresses.filter(function (address) {
    return address.startedAt && (0, date_fns_1.isValid)(new Date(address.startedAt)) && address.endedAt && (0, date_fns_1.isValid)(new Date(address.endedAt));
  }).map(function (address) {
    return {
      address: address,
      daysOverlap: (0, date_fns_1.getOverlappingDaysInIntervals)({
        start: (0, date_fns_1.subDays)(new Date(), 910),
        end: (0, date_fns_1.subDays)(new Date(), 730)
      }, {
        start: new Date(address.startedAt),
        end: new Date(address.endedAt)
      })
    };
  }), ["daysOverlap"], ["desc"]);
  return (0, lodash_1.get)(addressesOrderedByDaysOverlap, "[0].address.state");
}

exports.default = determineExemptionState;